module.exports = __webpack_public_path__ + "static/img/clubempire-card-gold.54cec7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-img/clubempire-card-gold.png
// module id = 627
// module chunks = 1